import CityLandingPage from './page';

const sbcData = {
  cityName: 'São Bernardo do Campo',
  state: 'SP',
  slug: 'palestra-silenciosa-sao-bernardo-do-campo',
  coordinates: { lat: -23.6914, lng: -46.5647 },
  phone: '(11) 91777-6227',
  localKeywords: [
    'palestra silenciosa sao bernardo do campo',
    'silent conference abc paulista',
    'aluguel fones sem fio abc',
    'eventos corporativos sao bernardo',
    'tradução simultânea abc paulista',
    'festa silenciosa grande abc',
  ],
  heroTitle: 'palestra silenciosa são bernardo do campo',
  heroSubtitle: 'Tecnologia de áudio sem fio premium para eventos corporativos em São Bernardo do Campo e região do ABCD Paulista. Berço da indústria automobilística com expertise em eventos empresariais de grande porte.',
  localStats: { clients: '65+', satisfaction: '97%' },
  localTestimonials: [],
  localFAQs: [
    { question: 'Vocês atendem toda a região do ABCD Paulista?', answer: 'Sim! Atendemos São Bernardo do Campo, Santo André, São Caetano do Sul, Diadema, Mauá, Ribeirão Pires e toda a região do Grande ABCD. Cobertura completa com agilidade.' },
    { question: 'Qual o prazo para contratar em São Bernardo do Campo?', answer: 'Recomendamos 2 semanas para eventos padrão e 1 mês para grandes convenções industriais na região. Nossa proximidade com o ABCD permite atender demandas urgentes com rapidez.' },
    { question: 'Vocês têm experiência com o setor automotivo e industrial?', answer: 'Sim, o ABCD é o coração da indústria automobilística brasileira e nós conhecemos bem esse mercado. Atendemos montadoras, autopeças e entidades industriais com soluções de áudio que atendem aos padrões mais exigentes.' },
    { question: 'Quantos fones estão disponíveis para São Bernardo e ABCD?', answer: 'De workshops e treinamentos industriais (30 fones) a grandes convenções setoriais (350+ fones). Todo equipamento é robusto e adequado para ambientes industriais, com alcance de 100m sem interferência.' },
    { question: 'A transmissão funciona bem em galpões e áreas industriais do ABCD?', answer: 'Perfeitamente! Nossos equipamentos são projetados para ambientes industriais desafiadores. O sistema opera em frequência dedicada, sem interferência de máquinas ou equipamentos eletrônicos.' },
  ],
  seoTitle: 'São Bernardo do Campo Palestra Silenciosa | Aluguel Fones ABCD | STIB',
  seoDescription: 'Palestra silenciosa São Bernardo do Campo: aluguel de fones sem fio para eventos corporativos e industriais no ABCD Paulista. Polo automotivo. Solicite orçamento!',
  relatedCities: [
    { name: 'São Paulo (Capital)', slug: '/sao-paulo', region: 'Capital' },
    { name: 'Campinas', slug: '/campinas', region: 'Região Metropolitana' },
    { name: 'Barueri / Alphaville', slug: '/barueri', region: 'Grande SP Oeste' },
    { name: 'São José dos Campos', slug: '/sao-jose-dos-campos', region: 'Vale do Paraíba' },
    { name: 'Ribeirão Preto', slug: '/ribeirao-preto', region: 'Interior Norte' },
    { name: 'Santos', slug: '/santos', region: 'Baixada Santista' },
    { name: 'Guarulhos', slug: '/guarulhos', region: 'Grande SP Leste' },
    { name: 'Jundiaí', slug: '/jundiai', region: 'Interior Oeste' },
  ],
};

export default function SbcLandingPage() {
  return <CityLandingPage cityData={sbcData} />;
}